module.exports = function(service) {
	'use strict'
	service.factory('cleanArray', cleanArray);
	cleanArray.$inject = [];
	function cleanArray() {
	   return {
		   	clean : function(test_array) {
			   	var index = -1,
			        arr_length = test_array ? test_array.length : 0,
			        resIndex = -1,
			        result = [];

			    while (++index < arr_length) {
			        var value = test_array[index];

			        if (value) {
			            result[++resIndex] = value;
			        }
			    }

			    return result;
	        }
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/cleanArrayService.js
// module id = 588
// module chunks = 0